function Waypoints() {
	var self = this;
	this.init();
}

Waypoints.prototype.init = function() {
	var self = this;
	this.showItemsOnLoad();
	this.showItemsOnScroll();
};

Waypoints.prototype.showItemsOnLoad = function() {
	var self = this;
	$(window).on('load', function() {
		var wp1 = $('.-load-wpt1'),
			wp2 = $('.-load-wpt2'),
			wp3 = $('.-load-wpt3');
		var load = [wp1, wp2, wp3];

		$.each(load, function() {
			$(this).addClass('-active');
		});
	});
};

Waypoints.prototype.showItemsOnScroll = function() {
	var self = this;

	var wp1 = $('.page-container > *:not(.popups) .-scroll-wpt1'),
		wp2 = $('.page-container > *:not(.popups) .-scroll-wpt2'),
		wp3 = $('.page-container > *:not(.popups) .-scroll-wpt3');

	var scroll = [wp1, wp2, wp3];

	$.each(scroll, function() {
		$(this).each(function() {
			var that = $(this);
			that.waypoint({
				element: that,
				handler: function(dir) {
					that.addClass('-active');
				},
				offset: '75%'
			});
		});
	});

	// $('.text-reveal, .block-reveal').each(function(i, el) {
	// 	el.waypoint = new Waypoint({
	// 		element: el,
	// 		handler: function(dir) {
	// 			if (!$(el).hasClass('-active')) {
	// 				$(el).addClass('-active');
	// 			}
	// 		},
	// 		offset: '75%'
	// 	});
	// });
	// $('.image-reveal').each(function(i, el) {
	// 	var that = $(this);
	// 	that.waypoint = new Waypoint({
	// 		element: el,
	// 		handler: function(dir) {
	// 			if (!that.hasClass('-scrolled')) {
	// 				that.addClass('-scrolled');
	// 				setTimeout(function() {
	// 					that.addClass('-visible');
	// 					setTimeout(function() {
	// 						that.addClass('-hidden-mask');
	// 					}, 600);
	// 				}, 600);
	// 			}
	// 		},
	// 		offset: '50%'
	// 	});
	// });
};